import {FieldArray, Form, Formik} from 'formik'
import {isEmpty} from 'lodash'
import {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import Modal from 'rsuite/Modal'
import {StateParamsModel} from 'src/app/modules/common/Model'
import FormSelect from 'src/cms/helpers/components/forms/FormSelect'
import * as Yup from 'yup'
import * as dynamicCompRedux from '../index'
// import {actions as dynamicCompRedux} from '../redux/action'
import * as cms from 'src/app/modules/cms'

import {IMenuState} from 'src/app/modules/cms/components/menu'
import {MenuOptionModal} from 'src/app/modules/cms/components/menu/Model'
import axios from 'axios'
import Select from 'react-select'
import {imageBaseUrl} from 'src/cms/helpers/constants'
import {ErrorMessage} from 'formik'
import {ReactSortable} from 'react-sortablejs'

type Props = {
  open: boolean
  params?: StateParamsModel
  handleClose: () => void
  actionType: string
  editSelectedData?: any
}

interface IServicePartnerState {
  data?: {
    servicePartner?: {[key: string]: number | string}[]
    meta: {[key: string]: number}
  }
  countryList?: {servicePartnerCountryList?: any[]}
  currencyList?: any[]
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  importLoading?: boolean
  importSuccess?: boolean
  countryLoading?: boolean
  countrySuccess?: boolean
  currencyLoading?: boolean
  currencySuccess?: boolean
  loading?: boolean
  success?: boolean
}

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

// UI-only stable key for react-sortablejs row identity (stripped before submit)
let _rowSeq = 0
const nextKey = () => `row-${++_rowSeq}`

const AddDynamicComponent = ({open, params, handleClose, actionType, editSelectedData}: Props) => {
  const dispatch = useDispatch()
  const [dynamicRes, setDynamicRes] = useState<any>({})
  const [componentOptions, setComponentOptions] = useState([])
  const [layoutOptions, setlayoutOptions] = useState([])
  const [updatedSelectedEdit, setUpdatedSelectedEdit] = useState<any>({})

  const [selectedComponent, setSelectedComponent] = useState<string>('')
  const draggingKeyRef = useRef<string | null>(null)
  const {topMenu} = useSelector((state: IMenuState | any) => state.menuManager)
  const {loading, success} = useSelector((state: any) => state.dynamicComponent)

  const getLayoutList = async () => {
    let res = await axios.get(`${API_URL}/home-page-component`)
    setDynamicRes(res?.data?.data)
  }

  useEffect(() => {
    dispatch(cms.menu.actions.getTopMenu())
    getLayoutList()
  }, [])

  useEffect(() => {
    if (dynamicRes?.components) {
      let compOptions = dynamicRes?.components?.map((items: any) => ({
        label: items.title,
        value: items.id,
        systemName: items.title,
      }))
      setComponentOptions(compOptions)
    }

    // working in this
    if (!isEmpty(editSelectedData) && dynamicRes?.components?.length > 0) {
      let udpatedComponent = editSelectedData?.components?.map((item: any) => {
        let updatedFilterOptions = filteredLayoutOptions(item.component_id)
        let filteredPreviewImg = updatedFilterOptions?.filter(
          (option: any) => option.value === item.layout_id
        )[0]?.image

        return {
          _k: nextKey(),
          id: item?.id,
          component_id: item?.component_id,
          layout_id: item.layout_id,
          layoutOptions: updatedFilterOptions,
          prevewImg: filteredPreviewImg,
        }
      })
      editSelectedData = {...editSelectedData, components: udpatedComponent}
      setUpdatedSelectedEdit(editSelectedData)
    }
  }, [dynamicRes])

  const filteredLayoutOptions = (selectedCompValue: any) => {
    let layout = dynamicRes?.components
      ?.filter((item: any) => item?.id === selectedCompValue)[0]
      ?.layouts?.layouts?.map((items: any) => ({
        label: items.title,
        value: items.id,
        systemName: items.title,
        image: items.image,
      }))

    return layout
  }

  useEffect(() => {
    if (selectedComponent) {
      let layout = dynamicRes?.components
        ?.filter((item: any) => item?.id === selectedComponent)[0]
        ?.layouts?.layouts?.map((items: any) => ({
          label: items.title,
          value: items.id,
          systemName: items.title,
          image: items.image,
        }))

      setlayoutOptions(layout)
    }
  }, [selectedComponent])

  const topMenuOptions = topMenu?.map((items: MenuOptionModal) => ({
    label: items.displayName,
    value: items.id,
    systemName: items.systemName,
  }))

  // useEffect(() => {
  //   if (!isEmpty(editSelectedData) && dynamicRes?.components?.length > 0) {
  //     let udpatedComponent = editSelectedData.components.map((item) => {
  //       console.info('item value here=============', item)
  //       let updatedFilterOptions = filteredLayoutOptions(item.component_id)
  //       return {
  //         id: item?.id,
  //         component_id: item?.component_id,
  //         layout_id: item.layout_id,
  //         layoutOptions: updatedFilterOptions,
  //       }
  //     })
  //     console.info('udpated component here-----------------', udpatedComponent)
  //     editSelectedData = {...editSelectedData, components: udpatedComponent}
  //     console.info('udpated eid seleccted data here-----------------', editSelectedData)
  //   }
  // }, [editSelectedData])

  useEffect(() => {
    if (success) {
      dispatch(dynamicCompRedux?.actions.getDynamicComponent(params))
      isEmpty(editSelectedData)
        ? toast.success('Dynamic Component added successfully')
        : toast.success('Dynamic Component edited successfully')
      dispatch(dynamicCompRedux?.actions?.resetDynamicComponent())
      handleClose()
    }
  }, [success])

  const FORM_VALIDATION = Yup.object().shape({
    menu_id: Yup.string().required('Required field'),
    components: Yup.array()
      .of(
        Yup.object().shape({
          component_id: Yup.string().required('Required field'),
          layout_id: Yup.string().required('Required field'),
        })
      )
      .min(1, 'At least one property is required'),
  })

  const CustomFormSelect = ({
    name,
    options,
    value,
    onChange,
    disabled = false,
    errors,
    touched,
  }: any) => (
    <div>
      <Select
        name={name}
        options={options}
        isDisabled={disabled}
        value={options?.find((option: any) => option?.value === value)}
        onChange={onChange}
        isClearable
      />
      <div className='fv-plugins-message-container text-danger fw-bolder small text-end mt-1'>
        <ErrorMessage name={name} component='div' className='field-error-message' />
      </div>
    </div>
  )

  // Human-readable component title for the reorder toast (component_id -> label)
  const componentLabel = (componentId: string) =>
    (componentOptions as any[])?.find((o: any) => o?.value === componentId)?.label || 'Section'

  // Single updating toast so repeated moves don't stack
  const notifyReorder = (msg: string) => {
    if (toast.isActive('reorder')) {
      toast.update('reorder', {render: msg, autoClose: 2500})
    } else {
      toast.info(msg, {toastId: 'reorder', autoClose: 2500})
    }
  }

  return (
    <div className='modal-container' data-cy='search-category-container'>
      <Modal
        open={open}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>{actionType} Dynamic Components</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={{
                menu_id: '',
                components: [
                  {
                    _k: nextKey(),
                    component_id: '',
                    layout_id: '',
                    layoutOptions: [],
                    prevewImg: '',
                  },
                ],
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values: any) => {
                const isEdit = !isEmpty(editSelectedData)
                // Whitelist only the fields the API expects. react-sortablejs mutates rows
                // with transient `chosen`/`selected` flags, and rows also carry UI-only
                // `_k`/`layoutOptions`/`prevewImg`; none of those must reach the backend.
                const formData = {
                  // The update saga builds the PUT URL from the body's top-level `id`
                  // (saga: service.updateDynamicComponent(body, action.payload?.id)),
                  // which is the menu id. Must be present for edit to target the right page.
                  id: editSelectedData?.id,
                  menu_id: values?.menu_id,
                  components: values?.components?.map((item: any) => ({
                    id: isEdit ? item?.id ?? null : null,
                    component_id: item?.component_id,
                    layout_id: item?.layout_id,
                  })),
                }

                if (!isEmpty(editSelectedData)) {
                  dispatch(
                    dynamicCompRedux.actions.updateDynamicComponent(formData, editSelectedData?.id)
                  )
                } else {
                  dispatch(dynamicCompRedux.actions.addDynamicComponent(formData))
                }
              }}
            >
              {({isSubmitting, touched, handleChange, errors, values, setFieldValue}) => {
                useEffect(() => {
                  if (!isEmpty(updatedSelectedEdit)) {
                    const fields = ['id', 'menu_id', 'components']
                    fields.forEach((field) =>
                      setFieldValue(field, updatedSelectedEdit[field], false)
                    )
                    setFieldValue('menu_id', updatedSelectedEdit?.menu_id, false)
                  }
                }, [updatedSelectedEdit])

                return (
                  <Form>
                    <div className='card-body border-top pt-5' data-cy='search-category-body'>
                      <div className='row'>
                        <div className='col-md-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            label='Top Menu'
                            name='menu_id'
                            // disabled={
                            //   !isEmpty(editSelectedData) || values?.province_id ? false : true
                            // }
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            options={topMenuOptions}
                            values={values}
                            setFieldValue={setFieldValue}
                            required
                          />
                        </div>
                      </div>

                      <div className='row'>
                        <FieldArray
                          name='components'
                          render={(arrayHelpers) => (
                            <div>
                              <h5 className='rs-modal-title mb-5'>Dynamic Components</h5>
                              {values?.components && values?.components.length > 0 ? (
                                <ReactSortable
                                  list={values.components as any[]}
                                  onStart={(evt: any) => {
                                    // capture the dragged row's stable key so the toast names it
                                    // unambiguously (delta-diffing ties on adjacent moves)
                                    draggingKeyRef.current =
                                      values.components[evt.oldIndex]?._k ?? null
                                  }}
                                  setList={(next: any[]) => {
                                    // react-sortablejs calls setList once on mount with the
                                    // same order (and again on every drag). Only push to Formik
                                    // when the order truly changed, so the mount-time call can't
                                    // update state during render or stomp the edit prefill.
                                    const orderChanged =
                                      next.length !== values.components.length ||
                                      next.some(
                                        (it: any, i: number) => it?._k !== values.components[i]?._k
                                      )
                                    if (orderChanged) {
                                      setFieldValue('components', next)
                                      const k = draggingKeyRef.current
                                      const newIdx = k
                                        ? next.findIndex((it: any) => it?._k === k)
                                        : -1
                                      if (newIdx >= 0) {
                                        notifyReorder(
                                          `${componentLabel(
                                            next[newIdx].component_id
                                          )} moved to position ${newIdx + 1}. Save to apply.`
                                        )
                                      }
                                      draggingKeyRef.current = null
                                    }
                                  }}
                                  handle='.rs-handle'
                                  animation={150}
                                >
                                  {values.components.map((responseData: any, index: any) => (
                                    <div className='row mb-4 align-items-start' key={responseData._k}>
                                      <div
                                        className='col-auto d-flex align-items-center'
                                        style={{paddingTop: '1.9rem'}}
                                      >
                                        <span
                                          className='rs-handle'
                                          title='Drag to reorder'
                                          style={{
                                            cursor: 'grab',
                                            fontSize: '1.2rem',
                                            color: '#9db0a5',
                                            userSelect: 'none',
                                          }}
                                        >
                                          &#10303;
                                        </span>
                                        <span
                                          className='badge bg-light text-dark ms-2'
                                          style={{fontFamily: 'monospace'}}
                                          title='Order on the page'
                                        >
                                          {index + 1}
                                        </span>
                                      </div>
                                      <div className='col-md-5 col-xs-12'>
                                        <label className='mb-1 fw-bolder fs-6 col-lg-4'>
                                          <span className='required'>Select Component</span>
                                        </label>
                                        <CustomFormSelect
                                          name={`components[${index}].component_id`}
                                          options={componentOptions}
                                          value={values?.components[index]?.component_id}
                                          onChange={(option: any) => {
                                            // Update the selected componentId
                                            setFieldValue(
                                              `components[${index}].component_id`,
                                              option?.value || ''
                                            )
                                            // Clear the layout_id when component changes
                                            setFieldValue(`components[${index}].layout_id`, '')
                                            // Update layout options based on selected component

                                            const updatedFilterOptions = filteredLayoutOptions(
                                              option?.value
                                            )
                                            setFieldValue(
                                              `components[${index}].layoutOptions`,
                                              updatedFilterOptions || []
                                            )
                                          }}
                                          errors={errors}
                                          touched={touched}
                                        />
                                      </div>
                                      <div className='col-md-5 col-xs-12 '>
                                        <label className='mb-1 fw-bolder fs-6 col-lg-4'>
                                          <span className='required'>Select Layout</span>
                                        </label>
                                        <CustomFormSelect
                                          name={`components[${index}].layout_id`}
                                          options={values?.components[index].layoutOptions} // Use individual layoutOptions for this component
                                          value={values?.components[index]?.layout_id}
                                          disabled={!values?.components[index]?.component_id}
                                          onChange={(option: any) => {
                                            setFieldValue(
                                              `components[${index}].layout_id`,
                                              option?.value || ''
                                            )
                                            setFieldValue(
                                              `components[${index}].prevewImg`,
                                              option?.image || ''
                                            )
                                          }}
                                          errors={errors}
                                          touched={touched}
                                        />
                                      </div>
                                      <div
                                        className='col-auto d-flex flex-column'
                                        style={{paddingTop: '1.9rem', gap: '2px'}}
                                      >
                                        <button
                                          type='button'
                                          className='btn btn-sm btn-light py-0 px-2'
                                          disabled={index === 0}
                                          onClick={() => {
                                            arrayHelpers.move(index, index - 1)
                                            notifyReorder(
                                              `${componentLabel(
                                                values.components[index]?.component_id
                                              )} moved to position ${index}. Save to apply.`
                                            )
                                          }}
                                          title='Move up'
                                          aria-label='Move up'
                                        >
                                          &#9650;
                                        </button>
                                        <button
                                          type='button'
                                          className='btn btn-sm btn-light py-0 px-2'
                                          disabled={index === values.components.length - 1}
                                          onClick={() => {
                                            arrayHelpers.move(index, index + 1)
                                            notifyReorder(
                                              `${componentLabel(
                                                values.components[index]?.component_id
                                              )} moved to position ${index + 2}. Save to apply.`
                                            )
                                          }}
                                          title='Move down'
                                          aria-label='Move down'
                                        >
                                          &#9660;
                                        </button>
                                      </div>
                                      <div
                                        className='col-auto d-flex align-items-center'
                                        style={{paddingTop: '1.9rem'}}
                                      >
                                        <button
                                          type='button'
                                          className='btn btn-secondary btn-sm'
                                          disabled={values.components.length <= 1}
                                          onClick={() => arrayHelpers.remove(index)}
                                          data-cy='modal-field-remove'
                                          title='Remove'
                                        >
                                          Remove
                                        </button>
                                      </div>
                                      {values?.components[index]?.prevewImg && (
                                        <div className='col-md-6 col-xs-12 mt-4'>
                                          <label className='mb-1 fw-bolder fs-6 col-lg-4'>
                                            <span className='required'>Layout Preview</span>
                                          </label>
                                          <img
                                            className='thumbImage w-100 h-100'
                                            src={`${imageBaseUrl}/${values?.components[index]?.prevewImg}`}
                                            alt='layout preview'
                                          />
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </ReactSortable>
                              ) : null}

                              <div className=' d-flex justify-content-md-end mb-2 border-top border-light pt-5'>
                                <button
                                  className='p-2 ps-5 pe-5 btn btn-primary'
                                  type='button'
                                  onClick={() =>
                                    arrayHelpers.push({
                                      _k: nextKey(),
                                      component_id: '',
                                      layout_id: '',
                                      layoutOptions: [],
                                    })
                                  }
                                  data-cy='modal-field-add'
                                >
                                  + Add More
                                </button>
                              </div>
                            </div>
                          )}
                        />
                      </div>
                    </div>
                    <div className='d-flex justify-content-end px-9 '>
                      <button
                        type='submit'
                        disabled={loading}
                        className='btn btn-primary btn-sm ms-3'
                        data-cy='modal-submit'
                      >
                        Save
                      </button>
                      <button
                        type='button'
                        onClick={handleClose}
                        className='btn btn-secondary btn-sm ms-3'
                        data-cy='modal-cancel'
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default AddDynamicComponent
